export const logError = (message: string, error: Error) => {
  if (process.env.NODE_ENV !== 'production') {
    console.error(`${message}: `, error);
  }
};
